export default "__VITE_ASSET__CXoQPVY1__"